<!-- 侧边栏 -->
<template>
  <div class="layout-sidebar">
    <div class="logo">
      <img v-if="!isJinXiangHuaSheng" src="../../assets/logo3.png" alt="" style="width: 60% !important; vertical-align: middle;">
    </div>
    <el-menu ref="menu" class="menu-container" :default-active="active" router>
      <el-scrollbar style="height:100%">
        <template v-for="item in sidebar">
          <!-- 没有children时 -->
          <el-menu-item v-if="!item.hasChild" :key="item.key" v-permission="item.permission" :index="item.index">
            <i class="icon" :class="item.icon" />
            <template slot="title">
              <span>{{ $t(item.text) }}</span>
            </template>
          </el-menu-item>
          <!-- 有children时 -->
          <el-submenu v-if="item.hasChild" :key="item.key" v-permission="item.permission" :index="item.index">
            <template slot="title">
              <i class="icon" :class="item.icon" />
              <span>{{ $t(item.text) }}</span>
            </template>
            <el-menu-item v-for="(subitem, index) in item.children" :key="index" :index="subitem.index">{{
              $t(subitem.text)
            }}</el-menu-item>
          </el-submenu>
        </template>
      </el-scrollbar>
    </el-menu>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      active: '',
      sidebar: [],
      // 超级管理员菜单
      system: [
        {
          key: 0,
          index: '/home',
          icon: 'el-icon-s-marketing',
          text: 'sider.xtgk',
          hasChild: false,
          permission: [1, 2, 3, 4],
          children: []
        },
        {
          key: 1,
          index: '/list',
          icon: 'el-icon-notebook-2',
          text: 'sider.xtlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 2,
          index: '/compare',
          icon: 'el-icon-collection',
          text: 'sider.xtbj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 3,
          index: '/alarm',
          icon: 'iconfont icon-baojing',
          text: 'sider.bjzx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 4,
          index: '/import',
          icon: 'el-icon-s-tools',
          text: 'sider.sbdr',
          permission: [1],
          hasChild: false,
          children: []
        },
        {
          key: 5,
          index: '/auth',
          icon: 'fa fa-share-alt',
          text: 'sider.sbsq',
          permission: [1],
          hasChild: false,
          children: []
        },
        {
          key: 51,
          index: '/add',
          icon: 'el-icon-first-aid-kit',
          text: 'sider.xzdd',
          permission: [4],
          hasChild: false,
          children: []
        },
        {
          key: 52,
          index: '/manager',
          icon: 'fa fa-user-md',
          text: 'sider.yhgl',
          permission: [1, 2, 3],
          hasChild: false,
          children: []
        },
        {
          key: 53,
          index: '/timeshare',
          icon: 'el-icon-set-up',
          text: 'sider.fscx',
          permission: [1],
          hasChild: false,
          children: []
        },
        {
          key: 6,
          index: '/myInfo',
          icon: 'el-icon-info',
          text: 'sider.wdxx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 7,
          index: '/changepwd',
          icon: 'el-icon-lock',
          text: 'sider.xgmm',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        // {
        //   key: 8,
        //   index: '/camera',
        //   icon: 'el-icon-video-camera',
        //   text: 'sider.spjk',
        //   permission: [1],
        //   hasChild: false,
        //   children: []
        // },
        // {
        //   key: 9,
        //   index: '/devicerecharge',
        //   icon: 'fa fa-jpy',
        //   text: 'sider.deviceRecharge',
        //   permission: [4],
        //   hasChild: false,
        //   children: []
        // },
        // {
        //   key: 10,
        //   index: '/offlinenotify',
        //   icon: 'el-icon-s-promotion',
        //   text: 'sider.offlineNotify',
        //   permission: [1, 2, 3, 4],
        //   hasChild: false,
        //   children: []
        // }
      ],
      // 储能
      energy: [
        {
          key: 11,
          index: '/energy/home',
          icon: 'el-icon-s-home',
          text: 'sider.gk',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 12,
          index: '/energy/real',
          icon: 'iconfont icon-shishi',
          text: 'sider.sssj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 13,
          index: '/energy/history',
          icon: 'iconfont icon-lishi',
          text: 'sider.lssj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 131,
          index: '/energy/remote',
          icon: 'el-icon-sort',
          text: 'sider.ycsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 132,
          index: '/energy/collector',
          icon: 'el-icon-s-tools',
          text: 'sider.cjqlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 14,
          index: '/energy/report',
          icon: 'iconfont icon-baobiao',
          text: 'sider.bbxz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 15,
          index: '/energy/alarm',
          icon: 'iconfont icon-baojing',
          text: 'sider.bjlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 16,
          index: '/energy/station',
          icon: 'el-icon-setting',
          text: 'sider.cndzsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        }
      ],
      // 电表
      meter: [
        {
          key: 21,
          index: '/meter/home',
          icon: 'el-icon-s-home',
          text: 'sider.sjgk',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 22,
          index: '/meter/history',
          icon: 'iconfont icon-lishi',
          text: 'sider.lssj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 23,
          index: '/meter/compare',
          icon: 'el-icon-s-operation',
          text: 'sider.dbfx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 24,
          index: '/meter/list',
          icon: 'el-icon-menu',
          text: 'sider.sslb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        },
        {
          key: 25,
          index: '/meter/data',
          icon: 'el-icon-view',
          text: 'sider.zdsjcx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        },
        {
          key: 26,
          index: '/meter/station',
          icon: 'el-icon-setting',
          text: 'sider.dbdzsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        },
        {
          key: 27,
          index: '/meter/collector',
          icon: 'el-icon-s-tools',
          text: 'sider.cjqlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        },
        {
          key: 33,
          index: '/meter/alarm',
          icon: 'iconfont icon-baojing',
          text: 'sider.bjlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        },
        {
          key: 34,
          index: '/meter',
          icon: 'fa fa-bolt',
          text: 'sider.dnsj',
          hasChild: true,
          permission: [1, 2, 3, 4],
          children: [
            { index: '/meter/powerdatas', text: 'sider.tjdl' },
          ],
        },
        {
          key: 35,
          index: '/meter/link',
          icon: 'fa fa-caret-square-o-right',
          text: 'sider.dp',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        }
      ],
      // 组串
      series: [
        {
          key: 31,
          index: '/series/home',
          icon: 'el-icon-s-home',
          text: 'sider.gk',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 32,
          index: '/series/real',
          icon: 'iconfont icon-shishi',
          text: 'sider.sssj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 33,
          index: '/series/history',
          icon: 'iconfont icon-lishi',
          text: 'sider.lssj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 34,
          index: '/series/alarm',
          icon: 'iconfont icon-baojing',
          text: 'sider.bjlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 35,
          index: '/series/report',
          icon: 'iconfont icon-baobiao',
          text: 'sider.bbxz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 36,
          index: '/series/station',
          icon: 'iconfont icon-bianji',
          text: 'sider.zcdzsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 37,
          index: '/series/collector',
          icon: 'el-icon-s-tools',
          text: 'sider.cjqlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        // {
        //   key: 38,
        //   index: '/series/devlist',
        //   icon: 'el-icon-s-grid',
        //   text: 'sider.sblb',
        //   permission: [1],
        //   hasChild: false,
        //   children: []
        // },
        // {
        //   key: 39,
        //   index: '/series/link',
        //   icon: 'fa fa-caret-square-o-right',
        //   text: 'sider.dp',
        //   permission: [1, 2, 3, 4],
        //   hasChild: false,
        //   children: []
        // }
      ],
      // 气象
      weather: [
        {
          key: 41,
          index: '/weather/home',
          icon: 'el-icon-s-home',
          text: 'sider.sjgk',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 42,
          index: '/weather/search',
          icon: 'el-icon-search',
          text: 'sider.sjcx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 43,
          index: '/weather/compare',
          icon: 'el-icon-s-operation',
          text: 'sider.dbfx',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 44,
          index: '/weather/list',
          icon: 'el-icon-menu',
          text: 'sider.sblb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 45,
          index: '/weather/station',
          icon: 'el-icon-setting',
          text: 'sider.qxdzsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 46,
          index: '/weather/collector',
          icon: 'el-icon-s-tools',
          text: 'sider.cjqlb',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        }
      ],
      // 开关
      switch: [
        {
          key: 51,
          index: '/switch/home',
          icon: 'el-icon-s-home',
          text: 'sider.switch_real_control',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        },
        {
          key: 52,
          index: '/switch/stationsetting',
          icon: 'el-icon-setting',
          text: 'sider.switchStationSet',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        }
      ],
    }
  },
  computed: {
    isJinXiangHuaSheng: function () {
      return this.$store.getters.id === process.env.VUE_APP_JinXiangHuaSheng_Userid
    }
  },
  watch: {
    $route (val) {
      this.active = val.name === 'meter_lizhuSettlement' ? '/meter/settlement' : val.path
      this.setMenuContent(val)
      // if (val.path.indexOf('energy') !== -1) {
      //   this.sidebar = this.energy
      // } else if (val.path.indexOf('meter') !== -1) {
      //   this.muenMeter()
      // } else if (val.path.indexOf('series') !== -1) {
      //   this.muenSeries()
      // } else if (val.path.indexOf('weather') !== -1) {
      //   this.sidebar = this.weather
      // } else if (val.path.indexOf('switch') !== -1) {
      //   this.sidebar = this.switch
      // } else {
      //   this.muenSystem()
      // }
    }
  },
  mounted () {
    this.active = this.$route.name === 'meter_lizhuSettlement' ? '/meter/settlement' : this.$route.path
    this.setMenuContent(this.$route)
    // if (this.$route.path.indexOf('energy') !== -1) {
    //   this.sidebar = this.energy
    // } else if (this.$route.path.indexOf('meter') !== -1) {
    //   this.muenMeter()
    // } else if (this.$route.path.indexOf('series') !== -1) {
    //   this.muenSeries()
    // } else if (this.$route.path.indexOf('weather') !== -1) {
    //   this.sidebar = this.weather
    // } else if (this.$route.path.indexOf('switch') !== -1) {
    //   this.sidebar = this.switch
    // } else {
    //   this.muenSystem()
    // }
  },
  created () {
    this.$bus.$on('series', () => {
      this.sidebar = this.series
      this.$router.replace('/series/home')
    })
    this.$bus.$on('meter', () => {
      this.sidebar = this.meter
      this.$router.replace('/meter/home')
    })
    this.$bus.$on('energy', () => {
      this.sidebar = this.energy
      this.$router.replace('/energy/home')
    })
    this.$bus.$on('weather', () => {
      this.sidebar = this.weather
      this.$router.replace('/weather/home')
    })
    this.$bus.$on('switch', () => {
      this.sidebar = this.switch
      this.$router.replace('/switch/home')
    })
  },
  beforeDestroy () {
    this.$bus.$off('series')
    this.$bus.$off('meter')
    this.$bus.$off('weather')
    this.$bus.$off('energy')
    this.$bus.$off('relay')
  },
  methods: {
    muenMeter () {
      const meter = this.$deepClone(this.meter)
      if (this.$store.getters.control === 2 && !meter.some(o => {
        return o.key === 29
      })) {
        meter.push({
          key: 29,
          index: '/meter/aus',
          icon: 'el-icon-tickets',
          text: 'sider.bbdc',
          permission: [1, 2, 3, 4],
          hasChild: true,
          children: [
            { index: '/meter/aus/onereport', text: 'sider.rynbb' },
            { index: '/meter/aus/tworeport', text: 'sider.zdbb' },
          ],
        })
      } else if (this.$store.getters.control !== 2 && !meter.some(o => {
        return o.key === 30
      })) {
        meter.push({
          key: 30,
          index: '/meter/child',
          icon: 'el-icon-tickets',
          text: 'sider.bb',
          permission: [1, 2, 3, 4],
          hasChild: true,
          children: [
            { index: '/meter/report', text: 'sider.bbdc2' },
            { index: '/meter/settlement', text: 'sider.jsbg' },
          ],
        })
      }
      if (this.$store.getters.control === 2 && !meter.some(o => {
        return o.key === 31
      })) {
        meter.push({
          key: 31,
          index: '/meter/aus/details',
          icon: 'el-icon-reading',
          text: 'sider.dfxd',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        })
      }
      if (this.$store.getters.control === 2 && !meter.some(o => {
        return o.key === 32
      })) {
        meter.push({
          key: 32,
          index: '/meter/aus/billsettings',
          icon: 'el-icon-setting',
          text: 'sider.dfdsz',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: [],
        })
      }
      this.sidebar = meter
    },
    muenSeries () {
      const series = this.$deepClone(this.series)
      if (this.$store.getters.station.orgname === '东威研发中心' && !series.some(o => {
        return o.key === 38
      })) {
        series.push({
          key: 38,
          index: '/series/link',
          icon: 'fa fa-caret-square-o-right',
          text: 'sider.dp',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        })
      }
      this.sidebar = series
    },
    muenSystem () {
      const system = this.$deepClone(this.system)
      if (this.$store.state.user.flag === 1 && !system.some(o => {
        return o.key === 2
      })) {
        system.unshift({
          key: 2,
          index: '/compare',
          icon: 'el-icon-collection',
          text: 'sider.xtbj',
          permission: [1, 2, 3, 4],
          hasChild: false,
          children: []
        })
      }
      if (this.$store.state.user.flag === 1 && !system.some(o => {
        return o.key === 0
      })) {
        system.unshift({
          key: 0,
          index: '/home',
          icon: 'el-icon-s-marketing',
          text: 'sider.xtgk',
          hasChild: false,
          permission: [1, 2, 3, 4],
          children: []
        })
      }
      this.sidebar = system
    },
    setMenu_JinXiangHuaSheng () {
      let jinXiangHuaShengMenus = this.weather
      if (this.$route.path.indexOf('weather') !== -1) {
        jinXiangHuaShengMenus = [
          {
            key: 41,
            index: '/weather/home',
            icon: 'el-icon-s-home',
            text: 'sider.sjgk',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 42,
            index: '/weather/search',
            icon: 'el-icon-search',
            text: 'sider.sjcx',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 43,
            index: '/weather/compare',
            icon: 'el-icon-s-operation',
            text: 'sider.dbfx',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 44,
            index: '/weather/list',
            icon: 'el-icon-menu',
            text: 'sider.sblb',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 45,
            index: '/weather/station',
            icon: 'el-icon-setting',
            text: 'sider.qxdzsz',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 46,
            index: '/weather/collector',
            icon: 'el-icon-s-tools',
            text: 'sider.cjqlb',
            permission: [3],
            hasChild: false,
            children: []
          }
        ]
      } else {
        jinXiangHuaShengMenus = [
          {
            key: 1,
            index: '/list',
            icon: 'el-icon-notebook-2',
            text: 'sider.xtlb',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 51,
            index: '/add',
            icon: 'el-icon-first-aid-kit',
            text: 'sider.xzdd',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 6,
            index: '/myInfo',
            icon: 'el-icon-info',
            text: 'sider.wdxx',
            permission: [3],
            hasChild: false,
            children: []
          },
          {
            key: 7,
            index: '/changepwd',
            icon: 'el-icon-lock',
            text: 'sider.xgmm',
            permission: [1, 2, 3, 4],
            hasChild: false,
            children: []
          },
        ]
      }
      this.sidebar = jinXiangHuaShengMenus
    },
    setMenuContent (router) {
      if (this.isJinXiangHuaSheng) {
        this.setMenu_JinXiangHuaSheng()
      } else {
        this.active = router.name === 'meter_lizhuSettlement' ? '/meter/settlement' : router.path
        if (router.path.includes('energy')) {
          this.sidebar = this.energy
        } else if (router.path.includes('meter')) {
          this.muenMeter()
        } else if (router.path.includes('series')) {
          this.muenSeries()
        } else if (router.path.includes('weather')) {
          this.sidebar = this.weather
        } else if (router.path.includes('switch')) {
          this.sidebar = this.switch
        } else {
          this.muenSystem()
        }
      }
    }
  }
}
</script>
<style>
.layout-sidebar {
  --sidebar-width: 200px;
  --logo-height: 98px;

  position: fixed;
  top: var(--logo-height);
  bottom: 0;
  left: 0;
  width: var(--sidebar-width);
  height: calc(100% - var(--logo-height));
}
.layout-sidebar .logo {
  background-color: #1C2550;
  position: fixed;
  top: 0;
  width: var(--sidebar-width);
  height: var(--logo-height);
  text-align: center;
  line-height: var(--logo-height);
}
.layout-sidebar .menu-container {
  height: 100%;
  background-color: #0d163f;
  border: none;
  overflow: hidden;
}
.layout-sidebar .el-menu {
  background-color: #0d163f;
}

.layout-sidebar .el-submenu .el-menu-item {
  background-color: #0d163f;
  color: #fff;
}
.layout-sidebar .el-submenu .el-menu-item.is-active {
  background-color: rgba(19,208,121,0.5) !important;
}
.layout-sidebar .el-submenu__title:hover {
  background-color: rgba(19,208,121,0.3);
}
.layout-sidebar .el-menu .icon {
  font-size: 20px;
  width: 20px;
  color: #fff;
}
.layout-sidebar .el-submenu .icon {
  font-size: 20px;
}
.layout-sidebar .el-submenu .el-menu-item {
  padding-left: 60px !important;
  color: #fff;
}
.layout-sidebar .el-submenu__title:hover {
  background-color: rgba(19,208,121,0.3) !important;
}
.layout-sidebar .el-submenu__title:hover span {
  color: #fff;
}

.layout-sidebar .el-menu span {
  font-size: 16px;
  margin-left: 12px;
  color: #fff;
}
.layout-sidebar .el-menu .el-menu-item {
  padding-right: 60px;
}
.layout-sidebar .el-menu .el-menu-item:hover {
  background-color: rgba(19,208,121,0.3);
}
.layout-sidebar .el-menu .el-menu-item i {
  color: #fff;
}
.layout-sidebar .el-submenu .el-menu-item {
  padding-left: 60px !important;
}
.layout-sidebar .el-menu .el-menu-item.is-active {
  background-color: rgba(19,208,121,0.5) !important;
  color: #fff;
}
.layout-sidebar .el-menu-item.is-active .icon {
  color: #fff;
}
.layout-sidebar .el-menu-item.is-active span {
  color: #fff;
}
.layout-sidebar .el-menu-item.is-active > li {
  color: #fff;
}
.layout-sidebar .el-menu-item:not(.is-disabled):not(.is-active):hover span,
.layout-sidebar .el-menu .el-submenu:not(.is-disabled)>.el-submenu__title:hover span {
  color: #fff;
}

</style>
